export const HEADER_IDENTITY_KIND = {
  LOADING: "loading",
  USER: "user",
  TALENT: "talent",
  GUEST: "guest",
};

export const TALENT_FALLBACK_AVATAR = "/elite-core-placeholder-avatar.png";

export function isAuthenticatedUser(authState) {
  return Boolean(authState?.status && authState?.id);
}

export function getTalentDisplayName(member) {
  const displayName = String(member?.displayName || "").trim();
  if (displayName) return displayName;

  const firstName = String(member?.firstName || "").trim();
  const lastName = String(member?.lastName || "").trim();
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;

  const companyName = String(member?.companyName || member?.memberName || "").trim();
  if (companyName) return companyName;

  const email = String(member?.email || "").trim();
  if (email) return email;

  return "Talent";
}

export function getHeaderInitials(displayName, fallback = "U") {
  const words = String(displayName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!words.length) return fallback;

  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
}

export function getTalentAvatarUrl(member) {
  const candidate = String(
    member?.profileImageUrl || member?.avatarUrl || member?.profilePicture || ""
  ).trim();
  return candidate || TALENT_FALLBACK_AVATAR;
}

export function isTalentRoute(pathname) {
  const normalizedPathname = String(pathname || "");
  return normalizedPathname === "/talent" || normalizedPathname.startsWith("/talent/");
}

export function buildTalentHeaderIdentity(member, onTalentLogout) {
  const displayName = getTalentDisplayName(member);
  return {
    kind: HEADER_IDENTITY_KIND.TALENT,
    id: member?.id,
    displayName,
    subtitle: member?.companyName || member?.email || "Talent",
    avatarUrl: getTalentAvatarUrl(member),
    initials: getHeaderInitials(displayName, "T"),
    menuItems: [
      { label: "Talent Profile", to: "/talent/profile" },
      { label: "Talent Dashboard", to: "/talent" },
    ],
    onLogout: onTalentLogout,
  };
}

export function resolveHeaderIdentity({
  pathname,
  authState,
  isUserLoading,
  userAvatarUrl,
  onUserLogout,
  talentAuth,
  onTalentLogout,
}) {
  if (isTalentRoute(pathname)) {
    if (talentAuth?.isLoading) {
      return { kind: HEADER_IDENTITY_KIND.LOADING };
    }

    if (talentAuth?.member) {
      return buildTalentHeaderIdentity(talentAuth.member, onTalentLogout);
    }

    return { kind: HEADER_IDENTITY_KIND.GUEST };
  }

  if (isAuthenticatedUser(authState)) {
    return {
      kind: HEADER_IDENTITY_KIND.USER,
      id: authState.id,
      displayName: authState.first_name || authState.email || "User",
      avatarUrl: userAvatarUrl || TALENT_FALLBACK_AVATAR,
      initials: getHeaderInitials(authState.first_name || authState.email || "User"),
      menuItems: [
        { label: "My profile", to: `/profile/${authState.id}` },
        ...(authState.role === "owner"
          ? [{ label: "Admin", to: "/admin/user-management", className: "adminButton" }]
          : []),
      ],
      onLogout: onUserLogout,
    };
  }

  if (isUserLoading) {
    return { kind: HEADER_IDENTITY_KIND.LOADING };
  }

  if (talentAuth?.isLoading) {
    return { kind: HEADER_IDENTITY_KIND.LOADING };
  }

  if (talentAuth?.member) {
    return buildTalentHeaderIdentity(talentAuth.member, onTalentLogout);
  }

  return { kind: HEADER_IDENTITY_KIND.GUEST };
}
